"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadingsQuery = exports.KAPI_PAGINATION_LIMIT = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var legacy_queries_1 = require("../../../../shared/api/legacy-queries");
var core_1 = require("../../../../shared/core");
var supply_points_1 = require("../../../billing/utils/supply-points");
var MeterReadingsContext_1 = require("../../MeterReadingsContext");
var utils_1 = require("../../utils");
var Error_1 = require("./Error");
var mapping_1 = require("./mapping");
var use_meter_reads_kapi_query_1 = require("./use-meter-reads-kapi-query");
var utils_2 = require("./utils");
var get_combined_omrs_1 = require("./utils/get-combined-omrs");
// Temporary hardcoded limit to number of reads requested
// This is to attempt to keep under Kapi's response size limit
// while we don't have time to implement proper pagination
exports.KAPI_PAGINATION_LIMIT = 500;
function ResponseDataHandler(_a) {
    var readings = _a.readings, supplies = _a.supplies, latestBilling = _a.latestBilling, supplyRegisterInfo = _a.supplyRegisterInfo, children = _a.children;
    var contextValue = (0, react_1.useMemo)(function () {
        return (0, utils_2.responseToState)({
            readings: readings,
            supplies: supplies,
            latestBilling: latestBilling,
            supplyRegisterInfo: supplyRegisterInfo,
        });
    }, [readings, supplies, latestBilling, supplyRegisterInfo]);
    return (react_1.default.createElement(MeterReadingsContext_1.MeterReadingsContext.Provider, { value: contextValue }, children));
}
var mostRecentFirst = function (a, b) {
    return (0, date_fns_1.isBefore)(a.readingDateTime, b.readingDateTime) ? 1 : -1;
};
var Data = function (_a) {
    var _b, _c;
    var queryResultsArray = _a.data, _d = _a.props, children = _d.children, queryResultsIndex = _d.queryResultsIndex, supplyPoints = _d.supplyPoints, latestBilling = _d.latestBilling;
    var openingMeterReadings = queryResultsArray[queryResultsIndex.findIndex(function (data) { return data.id === 'onboarding'; })] || [];
    var combinedOMRs = (0, get_combined_omrs_1.getCombinedOMRs)(openingMeterReadings);
    var elecReadings = queryResultsArray[queryResultsIndex.findIndex(function (data) { return data.id === 'electricity'; })] || [];
    var kapiReadings = queryResultsArray[queryResultsIndex.findIndex(function (data) { return data.id === 'kapi'; })];
    var mappedKapiReadings = kapiReadings
        ? (0, mapping_1.mapMeterReadingQueryKapiToMeterReadingCX)(kapiReadings)
        : [];
    var supplyRegisterInfo = kapiReadings
        ? (0, mapping_1.getSupplyRegisterInfo)(kapiReadings)
        : undefined;
    var gasReadings = queryResultsArray[queryResultsIndex.findIndex(function (data) { return data.id === 'gas'; })] || [];
    var readings = {
        electricity: __spreadArray(__spreadArray(__spreadArray([], __read(combinedOMRs.electricity), false), __read((0, utils_1.mapMPXN)(elecReadings, ((_b = queryResultsIndex.find(function (data) { return data.id === 'electricity'; })) === null || _b === void 0 ? void 0 : _b.mpxn) || '')), false), __read(mappedKapiReadings), false).sort(mostRecentFirst),
        gas: __spreadArray(__spreadArray([], __read(combinedOMRs.gas), false), __read((0, utils_1.mapMPXN)(gasReadings, ((_c = queryResultsIndex.find(function (data) { return data.id === 'gas'; })) === null || _c === void 0 ? void 0 : _c.mpxn) || '')), false).sort(mostRecentFirst),
    };
    return (react_1.default.createElement(ResponseDataHandler, { readings: readings, supplies: supplyPoints, latestBilling: latestBilling, supplyRegisterInfo: supplyRegisterInfo }, children));
};
function MeterReadingsQuery(_a) {
    var supplyPoints = _a.supplyPoints, latestBilling = _a.latestBilling, accountId = _a.accountId, children = _a.children, NoData = _a.NoData, Error = _a.Error;
    var kapi = core_1.configService.getConfig().kapi;
    // Don't request reads for inactive supplies.
    var activeSupplies = supplyPoints.filter(supply_points_1.isActiveSupply);
    var callKapi = (0, utils_1.hasComplexSupplies)(supplyPoints) || (kapi && kapi.meterReads);
    // Return a list of required queries for this account.
    var queriesRequired = activeSupplies.reduce(function (queryList, supply) {
        var _a, _b, _c, _d;
        var result = __spreadArray([], __read(queryList), false);
        var isOnboarding = supply.isOnboarding || supply.supplyPointInfo === null;
        if (isOnboarding) {
            if (!queryList.some(function (data) { return data.id === 'onboarding'; })) {
                result.push({ id: 'onboarding', mpxn: (_a = supply.mpxn) !== null && _a !== void 0 ? _a : '' });
            }
            return result;
        }
        if (supply.fuel === 'Electricity') {
            if (callKapi && !queryList.some(function (data) { return data.id === 'kapi'; })) {
                result.push({ id: 'kapi', mpxn: (_b = supply.mpxn) !== null && _b !== void 0 ? _b : '' });
            }
            if (!callKapi && !queryList.some(function (data) { return data.id === 'electricity'; })) {
                result.push({ id: 'electricity', mpxn: (_c = supply.mpxn) !== null && _c !== void 0 ? _c : '' });
            }
        }
        if (supply.fuel === 'Gas') {
            result.push({ id: 'gas', mpxn: (_d = supply.mpxn) !== null && _d !== void 0 ? _d : '' });
        }
        return result;
    }, []);
    // Conditionally setup each query using queriesRequired.includes() to enable or disable.
    var meterReadingsQueryGasResult = (0, legacy_queries_1.useManualReadingsLegacyQuery)((0, utils_2.getDataForQuery)(accountId, supplyPoints, 'Gas'), {
        enabled: queriesRequired.some(function (data) { return data.id === 'gas'; }),
    });
    var meterReadingsQueryElecResult = (0, legacy_queries_1.useManualReadingsLegacyQuery)((0, utils_2.getDataForQuery)(accountId, supplyPoints, 'Electricity'), {
        enabled: queriesRequired.some(function (data) { return data.id === 'electricity'; }),
    });
    var meterReadingsKapiQueryResult = (0, use_meter_reads_kapi_query_1.useMeterReadsKapiQuery)({
        variables: {
            accountId: accountId,
            first: exports.KAPI_PAGINATION_LIMIT,
        },
        skip: !queriesRequired.some(function (data) { return data.id === 'kapi'; }),
    });
    var openingMeterReadingsResult = (0, legacy_queries_1.useOpeningMeterReadingsLegacyQuery)(accountId, {
        enabled: queriesRequired.some(function (data) { return data.id === 'onboarding'; }),
    });
    // Ignore unused queries by mapping used queries to the same position as the queriesRequired array.
    var queryResultsArray = queriesRequired.map(function (_a) {
        var queryNext = _a.id;
        if (queryNext === 'onboarding') {
            return openingMeterReadingsResult;
        }
        if (queryNext === 'electricity') {
            return meterReadingsQueryElecResult;
        }
        if (queryNext === 'kapi') {
            return meterReadingsKapiQueryResult;
        }
        return meterReadingsQueryGasResult;
    });
    if (!queryResultsArray.length) {
        return (react_1.default.createElement(Error_1.ErrorMessage, { errorMetadata: { message: 'No supplies on this account' } }));
    }
    return (react_1.default.createElement(ui_tools_1.QueryResultRenderer, { forwardProps: {
            children: children,
            supplyPoints: supplyPoints,
            latestBilling: latestBilling,
            queryResultsIndex: queriesRequired,
        }, queryResults: queryResultsArray, NoData: NoData, Error: Error, Data: Data }));
}
exports.MeterReadingsQuery = MeterReadingsQuery;
